var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "date-input",
    on: {
      "click": _vm.openDatepicker
    }
  }, [_vm._v(" Effective date : "), _c('input', {
    staticClass: "date-picker",
    attrs: {
      "type": "date",
      "format": _vm.format
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput,
      "change": _vm.onChange
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }